module.exports = __webpack_public_path__ + "img/voucher.82643aad.svg";